import { render, staticRenderFns } from "./SubmitForm1.vue?vue&type=template&id=f08f68ee&scoped=true"
import script from "./SubmitForm1.vue?vue&type=script&lang=ts"
export * from "./SubmitForm1.vue?vue&type=script&lang=ts"
import style0 from "./SubmitForm1.vue?vue&type=style&index=0&id=f08f68ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08f68ee",
  null
  
)

export default component.exports